import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://groovie-business-api-production.up.railway.app/api/v1';

const FORMATS = ['Top 40','R&B / Soul','Hip-Hop','Gospel / Christian','Jazz / Blues','Country','Rock','Latin / Reggaeton','Afrobeats','News / Talk','Sports','Classical'];

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    name: '', email: '', password: '', confirm: '',
    callsign: '', city: '', state: '', format: '', market: '',
    terms: false
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    if (!form.terms) { setError('You must accept the terms'); return; }
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/broadcast/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: form.name, email: form.email, password: form.password, callsign: form.callsign, city: form.city, state: form.state, format: form.format, market: form.market })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Registration failed');
      localStorage.setItem('broadcast_token', data.token);
      if (data.station) localStorage.setItem('broadcast_station', JSON.stringify(data.station));
      navigate('/onboarding');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inp = (k, placeholder, type='text') => (
    <div>
      <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5, textTransform:'capitalize' }}>{k.replace('_',' ')}</label>
      <input
        type={type} required value={form[k]}
        onChange={e => set(k, e.target.value)}
        placeholder={placeholder}
        style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #e2e8f0', borderRadius:8, fontSize:14, outline:'none', boxSizing:'border-box' }}
        onFocus={e => e.target.style.borderColor='#6366f1'}
        onBlur={e => e.target.style.borderColor='#e2e8f0'}
      />
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#1e1b4b 0%,#312e81 60%,#4338ca 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ background:'#fff', borderRadius:16, padding:40, width:'100%', maxWidth:460, boxShadow:'0 25px 50px rgba(0,0,0,0.25)' }}>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <div style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:48, height:48, borderRadius:12, background:'linear-gradient(135deg,#6366f1,#818cf8)', marginBottom:10, cursor:'pointer' }} onClick={() => { window.location.href = 'https://groovie.live'; }} title="Groovie home">
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth={2} style={{width:24,height:24}}>
              <circle cx="12" cy="12" r="2"/><path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5"/><path d="M19.1 4.9C23 8.8 23 15.2 19.1 19.1"/>
            </svg>
          </div>
          <h1 style={{ margin:0, fontSize:20, fontWeight:800, color:'#0f172a' }}>Register Your Station</h1>
          <p style={{ margin:'4px 0 0', fontSize:13, color:'#64748b' }}>Step {step} of 2</p>
        </div>

        {/* Step indicator */}
        <div style={{ display:'flex', gap:6, marginBottom:24 }}>
          {[1,2].map(s => (
            <div key={s} style={{ flex:1, height:3, borderRadius:2, background: step >= s ? '#6366f1' : '#e2e8f0' }} />
          ))}
        </div>

        {error && (
          <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:'10px 14px', marginBottom:16, color:'#dc2626', fontSize:13 }}>
            {error}
          </div>
        )}

        {step === 1 ? (
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {inp('name', 'John Smith')}
            {inp('email', 'john@station.com', 'email')}
            {inp('password', 'â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢', 'password')}
            {inp('confirm', 'â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢', 'password')}
            <button
              onClick={() => { if (!form.name || !form.email || !form.password) { setError('All fields required'); return; } setError(''); setStep(2); }}
              style={{ width:'100%', padding:11, borderRadius:8, border:'none', cursor:'pointer', background:'linear-gradient(135deg,#6366f1,#4f46e5)', color:'#fff', fontWeight:700, fontSize:14 }}
            >
              Continue â†’
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {inp('callsign', 'WKRS 97.5')}
            {inp('city', 'Memphis')}
            {inp('state', 'TN')}
            {inp('market', 'Memphis Metro')}
            <div>
              <label style={{ display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:5 }}>Station Format</label>
              <select
                required value={form.format} onChange={e => set('format', e.target.value)}
                style={{ width:'100%', padding:'10px 12px', border:'1.5px solid #e2e8f0', borderRadius:8, fontSize:14, outline:'none', boxSizing:'border-box' }}
              >
                <option value="">Select formatâ€¦</option>
                {FORMATS.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
            </div>
            <label style={{ display:'flex', alignItems:'flex-start', gap:10, cursor:'pointer', fontSize:13, color:'#374151' }}>
              <input type="checkbox" checked={form.terms} onChange={e => set('terms', e.target.checked)} style={{ marginTop:2 }} />
              I accept the Groovie Broadcast Terms of Service and acknowledge this is a professional broadcasting account.
            </label>
            <div style={{ display:'flex', gap:10 }}>
              <button type="button" onClick={() => setStep(1)} style={{ flex:1, padding:11, borderRadius:8, border:'1.5px solid #e2e8f0', cursor:'pointer', background:'#fff', color:'#374151', fontWeight:600, fontSize:14 }}>â† Back</button>
              <button type="submit" disabled={loading} style={{ flex:2, padding:11, borderRadius:8, border:'none', cursor:loading?'not-allowed':'pointer', background: loading?'#c7d2fe':'linear-gradient(135deg,#6366f1,#4f46e5)', color:'#fff', fontWeight:700, fontSize:14 }}>
                {loading ? 'Creating accountâ€¦' : 'Create Account'}
              </button>
            </div>
          </form>
        )}

        <p style={{ textAlign:'center', marginTop:18, fontSize:13, color:'#64748b' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color:'#6366f1', fontWeight:600, textDecoration:'none' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
